import myAxios from './myAxios';

export function addPushToken({ token }) {
  return myAxios.post('/notifier/push-token/', {
    token,
  });
}
